import { Question } from '@psyomics/surveyjs-core';

import { Answers } from '../../survey-types';

const SKIPPED_QUESTION: unique symbol = Symbol('skippedAnswer');
const NOT_SHOWN_QUESTION: unique symbol = Symbol('notShownAnswer');

type AnswerValue = Answers[string] | typeof SKIPPED_QUESTION | typeof NOT_SHOWN_QUESTION;

class ConditionalAnswer {
  public readonly answer: AnswerValue;

  constructor(question: Question, answer: Answers[string]) {
    this.answer = this.getAnswerValue(question, answer);
  }

  private getAnswerValue(question: Question, answer: Answers[string]): AnswerValue {
    const trimmedAnswer = typeof answer === 'string' ? answer.trim() : answer;
    if (this.isANotShownQuestion(question)) return NOT_SHOWN_QUESTION;
    if (this.isASkippedAnswer(trimmedAnswer)) return SKIPPED_QUESTION;
    return trimmedAnswer;
  }

  private isANotShownQuestion(q: Question) {
    return !q.isVisible;
  }

  private isASkippedAnswer(answer: string | number | string[] | undefined) {
    return answer === undefined;
  }

  static isSkippedValue(value: AnswerValue): value is typeof SKIPPED_QUESTION {
    return value === SKIPPED_QUESTION;
  }

  static isNotShownValue(value: AnswerValue): value is typeof NOT_SHOWN_QUESTION {
    return value === NOT_SHOWN_QUESTION;
  }

  get isNotShown(): boolean {
    return ConditionalAnswer.isNotShownValue(this.answer);
  }

  get isSkipped(): boolean {
    return ConditionalAnswer.isSkippedValue(this.answer);
  }
}

export { ConditionalAnswer };
